module.exports = __webpack_public_path__ + "img/mouse.340d69ff.svg";